import React from "react";

export default function Help() {
  return (
    <div className="w-3/4">
      <h2>Help</h2>
      <p>Coming soon...</p>
    </div>
  );
}
